import React, { useEffect, useState } from 'react';
import { Link as Anchor, useSearchParams } from 'react-router-dom';
import baseURL from '../../Components/url';
import './ConfirmarCuenta.css';

export default function ConfirmarCuenta() {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('Estamos confirmando tu cuenta...');
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const token = searchParams.get('token') || '';
        if (!token) {
            setMessage('Falta el enlace de confirmacion.');
            setIsError(true);
            setLoading(false);
            return;
        }

        fetch(`${baseURL}/customerEmailVerify.php?token=${encodeURIComponent(token)}`, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setMessage(data.error);
                    setIsError(true);
                } else {
                    setMessage(data.mensaje || 'Tu cuenta fue confirmada correctamente.');
                    setIsError(false);
                }
            })
            .catch(() => {
                setMessage('No pudimos confirmar tu cuenta en este momento.');
                setIsError(true);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [searchParams]);

    return (
        <section className='confirmarCuentaPage'>
            <article className='confirmarCuentaCard'>
                <span className='confirmarCuentaEyebrow'>Tu Catálogo</span>
                <h1>Confirmacion de cuenta</h1>
                <p className={isError ? 'isError' : ''}>{message}</p>
                {!loading && (
                    <div className='confirmarCuentaActions'>
                        <Anchor to='/mi-cuenta'>Ir a mi cuenta</Anchor>
                        <Anchor to='/productos'>Ir a productos</Anchor>
                    </div>
                )}
            </article>
        </section>
    );
}
